<template>
  <div>
    <el-form :model="liveInfo" ref="liveInfo">
      <el-form-item label="直播名称" label-width="100px" prop="Title">
        <el-input v-model="liveInfo.Title"></el-input>
      </el-form-item>
      <el-form-item label="直播时间" label-width="100px" prop="Title">
        <el-date-picker style="width: 200px"
                        v-model="liveInfo.BeginTime"
                        :disabled="this.canChangeLiveTime()"
                        type="datetime"
                        placeholder="开始时间"
                        :picker-options="beginTimePickerOptions">
        </el-date-picker>
        <el-date-picker style="width: 200px"
                        v-model="liveInfo.EndTime"
                        :disabled="this.canChangeLiveTime()"
                        type="datetime"
                        placeholder="结束时间"
                        :picker-options="endTimePickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="授课老师" label-width="100px" prop="Title">
        <el-tag style="margin-right: 5px"
                :key="item"
                v-for="item in liveInfo.Teachers"
                closable
                @close="handleCloseTeacher(item)">
          {{item.Name}}
        </el-tag>
        <el-button size="small" icon="el-icon-plus" @click="addTeacher">选择授课老师</el-button>
      </el-form-item>
      <el-form-item label="助教" label-width="100px" prop="Title">
        <el-tag style="margin-right: 5px"
                :key="item"
                v-for="item in liveInfo.Assistants"
                closable
                @close="handleCloseAssistant(item)">
          {{item.Name}}
        </el-tag>
        <el-button size="small" icon="el-icon-plus" @click="addAssistant">选择助教</el-button>
      </el-form-item>
      <el-form-item label="课件云盘资源" label-width="100px" prop="Title">
        <el-input v-model="liveInfo.CloudDiskFiles"></el-input>
      </el-form-item>
    </el-form>
    <div style="padding-top: 10px;padding-left: 30px">
      <el-button @click="cancleBtnClick">取 消</el-button>
      <el-button type="primary" @click="okBtnClick">确 定</el-button>
    </div>
    <el-dialog title="添加老师" :visible.sync="dialogAddTeacherVisible" append-to-body>
      <select-user-component ref="addTeacherView" :showSearch="false" @selected="teacherSelect" @unSelected="teacherNnSelected"></select-user-component>
    </el-dialog>
    <el-dialog title="添加助教" :visible.sync="dialogAddAssistantVisible" append-to-body>
      <select-user-component ref="addAssistantView" :showSearch="false" @selected="assistantSelect" @unSelected="assistantNnSelected"></select-user-component>
    </el-dialog>
  </div>
</template>

<script>
import SelectUserComponent from '../selectuser/SelectUserComponent'
export default {
  name: 'ChangeLiveComponent',
  components: {SelectUserComponent},
  props: {
    liveInfo: {
      required: false
    }
  },
  data () {
    return {
      dialogAddTeacherVisible: false,
      allTeacherList: [],
      dialogAddAssistantVisible: false,
      allAssistantList: [],
      beginTimePickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '明天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }]
      },
      endTimePickerOptions: {
        disabledDate: this.endTimeisableData
      }
    }
  },
  methods: {
    endTimeisableData (time) {
      if (time.getTime() > this.liveInfo.BeginTime.getTime() + 3600 * 1000 * 24) {
        return true
      } else if (time.getTime() < this.liveInfo.BeginTime.getTime() - 3599 * 1000 * 24) {
        return true
      } else {
        return false
      }
    },
    canChangeLiveTime () {
      let flag = this.liveInfo.BeginTime.getTime() < new Date().getTime()
      return flag
    },
    cancleBtnClick () {
      this.$emit('CancleBtnClick')
    },
    okBtnClick () {
      this.$emit('OKBtnClick')
    },
    addTeacher () {
      this.dialogAddTeacherVisible = true
      this.getAllTeacher(1000, 1)
      this.$refs.addTeacherView.setSelectList(this.liveInfo.Teachers)
    },
    handleCloseTeacher (item) {
      this.remoteTeacher(this.liveInfo.Teachers, item)
    },
    teacherSelect (item) {
      this.liveInfo.Teachers.push(item)
      this.$refs.addTeacherView.selectedSuccess(item)
    },
    teacherNnSelected (item) {
      this.remoteTeacher(this.liveInfo.Teachers, item)
      this.$refs.addTeacherView.unSelectedSuccess(item)
    },
    getAllTeacher (count, page) {
      let requestData = {count: count, page: page}
      this.$api.userManager.getTeacherList(requestData).then((res) => {
        if (res.code === 0) {
          this.allTeacherList = res.data
          for (let i = 0; i < this.liveInfo.Teachers.length; i++) {
            let hasItem = this.liveInfo.Teachers[i]
            this.remoteTeacher(this.allTeacherList, hasItem)
          }
          this.$refs.addTeacherView.setUnSelectList(this.allTeacherList)
        }
      })
    },
    remoteTeacher (array, item) {
      // debugger
      for (let i = 0; i < array.length; i++) {
        let tmp = array[i]
        if (tmp.Id === item.Id) {
          array.splice(i, 1)
          return
        }
      }
    },
    addAssistant () {
      this.dialogAddAssistantVisible = true
      this.getAllAssistant(1000, 1)
      this.$refs.addAssistantView.setSelectList(this.liveInfo.Assistants)
    },
    handleCloseAssistant (item) {
      this.remoteAssistant(this.liveInfo.Assistants, item)
    },
    assistantSelect (item) {
      this.liveInfo.Assistants.push(item)
      this.$refs.addAssistantView.selectedSuccess(item)
    },
    assistantNnSelected (item) {
      this.remoteAssistant(this.liveInfo.Assistants, item)
      this.$refs.addAssistantView.unSelectedSuccess(item)
    },
    getAllAssistant (count, page) {
      let requestData = {count: count, page: page}
      this.$api.userManager.getAssistantList(requestData).then((res) => {
        if (res.code === 0) {
          this.allAssistantList = res.data
          for (let i = 0; i < this.liveInfo.Assistants.length; i++) {
            let hasItem = this.liveInfo.Assistants[i]
            this.remoteAssistant(this.allAssistantList, hasItem)
          }
          this.$refs.addAssistantView.setUnSelectList(this.allAssistantList)
        }
      })
    },
    remoteAssistant (array, item) {
      for (let i = 0; i < array.length; i++) {
        let tmp = array[i]
        if (tmp.Id === item.Id) {
          array.splice(i, 1)
          return
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/ChangeLiveComponent.vue